
import Icon from "../../../../../components/base/Icon";


export default function MCPTokenNotice() {
    return (
        <div className="fs-6 text-gray-800">

            <div className="text-center mb-8">
                <h2 className="fw-bolder mb-1 text-uppercase">Notice to Customers</h2>
                <div className="text-muted fs-6">Regarding AI-Generated Entries in the Rinvox Platform</div>
                <div className="badge badge-light-primary mt-3">Effective Date: June 17, 2026</div>
            </div>

            <p className="mb-5">
                Rinvox (&quot;the Company&quot;) wishes to inform all customers that its platform may be
                used in conjunction with third-party artificial intelligence tools and services that
                customers independently select and operate.
            </p>

            <p className="mb-5">
                Rinvox bears no responsibility for any data, content, instructions, or entries inputted
                into the Rinvox platform by customers through or with the assistance of their own AI tools.
                This includes, but is not limited to, job records, customer information, scheduling data,
                invoices, communications, and any other information generated or submitted via third-party
                AI systems.
            </p>

            <div className="fw-bold mb-3">Customers acknowledge and agree that:</div>
            <div className="mb-6">
                {
                    [
                        "They are solely responsible for the accuracy, legality, and appropriateness of any entries made into the Rinvox platform, whether inputted manually or through the use of any AI tool of their choosing.",
                        "Rinvox does not review, validate, or verify entries generated by third-party AI tools prior to their submission into the platform.",
                        "Any errors, omissions, inaccuracies, or damages arising from AI-generated entries are the sole responsibility of the customer.",
                        "Customers must ensure that their use of third-party AI tools in connection with the Rinvox platform complies with all applicable laws, regulations, and the Rinvox Terms of Service.",
                        "Rinvox's liability is strictly limited to the operation and availability of its own platform and features, as set forth in the applicable Terms of Service and any governing agreement between Rinvox and the customer.",
                    ].map((item, i) => (
                        <div key={i} className="d-flex align-items-start mb-3">
                            <Icon icon="circle-check" type="solid" className="text-primary mt-1 me-3 flex-shrink-0" />
                            <span>{item}</span>
                        </div>
                    ))
                }
            </div>

            <p className="mb-5">
                For questions regarding this notice, please contact us at{" "}
                <span className="fw-bold">+1 888 665 8656</span> or visit{" "}
                <a href="https://www.rinvox.com" target="_blank" rel="noreferrer">www.rinvox.com</a>.
            </p>

            <div className="separator my-6" />

            <div className="text-muted fs-7 text-center">Rinvox — Field Operations CRM for Contractors</div>

        </div>
    )
}
